/**
 * Swym wishlist hearts on product cards (snippets/card-wishlist.liquid).
 *
 * Swym only wires up (and only then shows) a listing button once
 * initializeActionButtons() has run over it. That method looks inside the FIRST
 * element its selector matches (document.querySelector), so a shared selector
 * would reach one heart per page. Each heart's wrapper therefore gets its own id
 * and is handed over on its own — on load, and again for cards rendered later
 * (filters, "show more", carousels and recommendations fetched with AJAX).
 * Buttons Swym has finished (.swym-loaded) or that were already handed over are
 * skipped, so no button gets Swym's listeners twice.
 */
(() => {
  const PENDING_SELECTOR = '.card__wishlist-btn:not(.swym-loaded):not([data-wl-init])';
  let swat = null;
  let scheduled = false;
  let uid = 0;

  function initButtons() {
    scheduled = false;
    if (!swat || typeof swat.initializeActionButtons !== 'function') return;

    document.querySelectorAll(PENDING_SELECTOR).forEach((button) => {
      const wrapper = button.closest('.card__wishlist');
      if (!wrapper) return;

      if (!wrapper.id) {
        uid += 1;
        wrapper.id = `card-wishlist-${uid}`;
      }
      button.setAttribute('data-wl-init', '');

      try {
        swat.initializeActionButtons(`#${wrapper.id}`);
      } catch (error) {
        console.error('Wishlist button could not be initialised', error); // eslint-disable-line no-console
      }
    });
  }

  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(initButtons);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((instance) => {
    swat = instance;
    initButtons();
  });

  document.addEventListener('on:facet-filters:updated', scheduleInit);

  new MutationObserver((mutations) => {
    if (!swat) return;
    const hasNewButtons = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
      node.nodeType === Node.ELEMENT_NODE
      && (node.matches(PENDING_SELECTOR) || node.querySelector(PENDING_SELECTOR))
    )));
    if (hasNewButtons) scheduleInit();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
